// extracted by mini-css-extract-plugin
module.exports = {"container":"ae73e__edit-name-module__container","input":"b7b98__edit-name-module__input"};